import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getFlaggedPins,
  getNextFlaggedPins,
  adminResolveFlaggedPin,
} from "../../actions/pins";
import { Link } from "react-router-dom";
import { Card } from "reactstrap";
const FLAG_TYPES = [
  { value: "all", label: "All Types" },
  { value: "1", label: "Suspicious/Spam" },
  { value: "2", label: "Harassment/Offensive" },
  { value: "3", label: "Inaccurate" },
  { value: "4", label: "Other" },
];

function ManageFlag() {
  const [showReport, setshowReport] = useState("");
  const [onlyFlagged, setOnlyFlagged] = useState(true);
  const [flagTypeFilter, setFlagTypeFilter] = useState("all");
  const [resolutionActionByPin, setResolutionActionByPin] = useState({});
  const [resolutionMessageByPin, setResolutionMessageByPin] = useState({});
  const [resolvingPinId, setResolvingPinId] = useState(null);
  const flagLimitNum = 5;
  const flaggedPins = useSelector((state) => state.pins.flaggedPins);
  const dispatch = useDispatch(); // dispatches the action
  const isFirstRender = useRef(true);

  useEffect(() => {
    //similar to component did mount
    dispatch(getFlaggedPins());
  }, [dispatch]);

  // Reset to page 1 whenever a filter changes
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    dispatch(getFlaggedPins());
  }, [onlyFlagged, flagTypeFilter, dispatch]);
  const toggleReports = (id) => {
    setshowReport((prevshowReport) => ({
      ...showReport,
      [id]: !prevshowReport[id],
    }));
  };

  const applyResolution = (pinId) => {
    const resolutionAction = resolutionActionByPin[pinId] || "delete_pin";
    const resolutionMessage = resolutionMessageByPin[pinId] || "";

    setResolvingPinId(pinId);
    dispatch(adminResolveFlaggedPin(pinId, resolutionAction, resolutionMessage))
      .then(() => {
        setResolutionActionByPin((prev) => ({ ...prev, [pinId]: "delete_pin" }));
        setResolutionMessageByPin((prev) => ({ ...prev, [pinId]: "" }));
      })
      .finally(() => {
        setResolvingPinId(null);
      });
  };

  return (
    <div className={"manage-container"}>
      manage flagged posts
      <div className="manage-filter-bar">
        <div className="manage-filter-row">
          <span className="manage-filter-label">status</span>
          <div className="manage-filter-pills">
            {[
              { value: false, label: "All Posts" },
              { value: true, label: "Flagged Only" },
            ].map((opt) => (
              <button
                key={String(opt.value)}
                className={`manage-filter-pill${onlyFlagged === opt.value ? " active" : ""}`}
                onClick={() => setOnlyFlagged(opt.value)}
              >
                {opt.label}
              </button>
            ))}
          </div>
        </div>
        <div className="manage-filter-row">
          <span className="manage-filter-label">type</span>
          <div className="manage-filter-pills">
            {FLAG_TYPES.map((t) => (
              <button
                key={t.value}
                className={`manage-filter-pill${flagTypeFilter === t.value ? " active" : ""}`}
                onClick={() => setFlagTypeFilter(t.value)}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>
      </div>
      <div className={"manage-paginate-buttons"}>
        <PrevNext next={flaggedPins.next} previous={flaggedPins.previous} />
      </div>
        {flaggedPins.results && (
          <ListFlags
            pins={flaggedPins.results}
            flagLimit={flagLimitNum}
            toggleReports={toggleReports}
            showReport={showReport}
            onlyFlagged={onlyFlagged}
            flagTypeFilter={flagTypeFilter}
            resolutionActionByPin={resolutionActionByPin}
            setResolutionActionByPin={setResolutionActionByPin}
            resolutionMessageByPin={resolutionMessageByPin}
            setResolutionMessageByPin={setResolutionMessageByPin}
            applyResolution={applyResolution}
            resolvingPinId={resolvingPinId}
          />
        )}
      </div>
  );
}

export default ManageFlag;

const PrevNext = (props) => {
  const dispatch = useDispatch();
  return (
    <>
      {props.previous ? (
        <button
          onClick={() => dispatch(getNextFlaggedPins(props.previous))}
          className="btn btn-sm default-btn-purple"
        >
          Previous{" "}
        </button>
      ) : (
        ""
      )}
      {props.next ? (
        <button
          onClick={() => dispatch(getNextFlaggedPins(props.next))}
          className="btn btn-sm default-btn-purple"
        >
          Next
        </button>
      ) : (
        ""
      )}
    </>
  );
};

function ListFlags(props) {
  const displayPins = props.pins
    .filter((p) => !props.onlyFlagged || p.flagscore > 0)
    .filter((p) => {
      if (props.flagTypeFilter === "all") return true;
      return (
        Array.isArray(p.flaggerstory) &&
        p.flaggerstory.some(
          (r) => String(r.reportType) === props.flagTypeFilter
        )
      );
    });

  const renderOwner = (pin) => {
    if (pin.username) {
      return <Link to={`/users/${pin.username}`}>{pin.username}</Link>;
    }

    if (pin.owner) {
      return `User #${pin.owner}`;
    }

    return "Unknown";
  };

  return (
    <Card className={"manage-card"}>
      <table
        className="table manage-table table-responsive-sm table-responsive-md"
        style={{ tableLayout: "fixed", width: "100%" }}
      >
        <thead className="manage-table-head">
          <th style={{ width: "16%" }}>story title</th>
          <th style={{ width: "12%" }}>owner</th>
          <th style={{ width: "10%" }}>number of flags</th>
          <th style={{ width: "28%" }}>action</th>
          <th style={{ width: "22%" }}>reason</th>
          <th style={{ width: "12%" }}>link to story</th>
        </thead>
        <tbody>
          {displayPins.map((pin, index) => {
            if (pin.flagscore >= 0) {
              return (
                <tr key={index}>
                  <td>{pin.title}</td>
                  <td>
                    <strong>{renderOwner(pin)}</strong>
                  </td>
                  <td>{pin.flagscore} flags</td>
                  <td className="manage-action-cell">
                    <div className="manage-action-controls">
                      <select
                        className="form-control form-control-sm"
                        value={props.resolutionActionByPin[pin.id] || "delete_pin"}
                        onChange={(e) =>
                          props.setResolutionActionByPin((prev) => ({
                            ...prev,
                            [pin.id]: e.target.value,
                          }))
                        }
                      >
                        <option value="delete_pin">Delete Pin</option>
                        <option value="clear_flag">Clear Flag</option>
                      </select>
                      <textarea
                        rows="2"
                        className="form-control form-control-sm"
                        placeholder="Admin note (optional)"
                        value={props.resolutionMessageByPin[pin.id] || ""}
                        onChange={(e) =>
                          props.setResolutionMessageByPin((prev) => ({
                            ...prev,
                            [pin.id]: e.target.value,
                          }))
                        }
                      />
                      <button
                        onClick={() => props.applyResolution(pin.id)}
                        className="btn btn-sm btn-block default-btn-purple"
                        disabled={props.resolvingPinId === pin.id}
                      >
                        {props.resolvingPinId === pin.id ? "Applying..." : "Address Flag"}
                      </button>
                    </div>
                  </td>
                  <td>
                    <button
                      onClick={() => props.toggleReports(pin.id)}
                      className="btn btn-sm default-btn-purple"
                    >
                      Show Reports
                    </button>
                    {props.showReport[pin.id]
                      ? pin.flaggerstory && (
                          <div className={"manage-reports"}>
                            <StoryReports reports={pin.flaggerstory} />
                          </div>
                        )
                      : null}
                  </td>
                  <td>
                    <Link
                      className="sidebar-story-read-more"
                      to={`/Story/${pin.id}`}
                    >
                      view story
                    </Link>
                  </td>
                </tr>
              );
            } else {
              return "";
            }
          })}
        </tbody>
      </table>
    </Card>
  );
}

const StoryReports = (props) => {
  const getReportTypeLabel = (reportType) => {
    const reportTypeMap = {
      1: "Suspicious/Spam",
      2: "Harassment/Offensive",
      3: "Inaccurate",
      4: "Other",
    };

    return reportTypeMap[Number(reportType)] || "Unknown";
  };

  const getFlaggerLabel = (report) => {
    if (report.flaggerUsername) {
      return report.flaggerUsername;
    }

    if (report.flagger) {
      return `User #${report.flagger}`;
    }

    return "Unknown user";
  };

  return (
    <ul className="manage-reports-list">
      {props.reports.length > 0
        ? props.reports.map((report) => {
            return (
              <li key={report.id} className="manage-reports-item">
                <div>
                  <strong>Flagged by:</strong> {getFlaggerLabel(report)}
                </div>
                <strong>{getReportTypeLabel(report.reportType)}:</strong>{" "}
                {report.reason || "No additional details provided."}
              </li>
            );
          })
        : "none"}
    </ul>
  );
};
